import { IVehicleStock } from '@common/interfaces';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAvailableVehicleStockList } from 'sales-common';

interface VehicleStockState {
  vehicleStock: IAvailableVehicleStockList[];
  selectedVehicleStock: IVehicleStock;
  selectedVehicleStockStatus: string;
}

const initialState: VehicleStockState = {
  vehicleStock: [],
  selectedVehicleStock: null,
  selectedVehicleStockStatus: '',
};

const vehicleStockSlice = createSlice({
  name: 'vehicleStock',
  initialState,
  reducers: {
    setSelectedVehicleStockStatus: (state, action: PayloadAction<string>) => {
      state.selectedVehicleStockStatus = action.payload;
    },
    setVehicleStock: (state, action: PayloadAction<IAvailableVehicleStockList[]>) => {
      state.vehicleStock = action.payload;
    },
    setSelectedVehicleStock: (state, action: PayloadAction<IVehicleStock>) => {
      state.selectedVehicleStock = action.payload;
    },
  },
});

export const { setVehicleStock, setSelectedVehicleStock, setSelectedVehicleStockStatus } = vehicleStockSlice.actions;
export default vehicleStockSlice.reducer;
